import React from "react";
import { useAttach } from "../hooks";
import { FormContext } from "../context";
export var FormProvider = function (props) {
    var form = useAttach(props.form);
    return React.createElement(FormContext.Provider, { value: form }, props.children);
};
FormProvider.displayName = "FormProvider";
